import { signOut } from "aws-amplify/auth"
import { Cache } from "aws-amplify/utils"
import { useNavigate, useRevalidator } from "react-router-dom"
import type { IClearUserDataFunc } from "../contexts"

export const useSignOutHandler = (
  clearUserData: IClearUserDataFunc | undefined
) => {
  const navigate = useNavigate()
  const revalidator = useRevalidator()
  return async () => {
    console.log("> custom sign out handler")
    await signOut()
    console.log("🔒 user is signed out")
    // Clear cache, because another user may log in on this browser.
    // This could be replaced by keeping the cache, and validating its content against the current user id.
    console.log("🧹 clearing cache")
    await Cache.clear()
    console.log("🧹 clearing localStorage")
    localStorage.clear()
    if (clearUserData) {
      console.log("🧹 clearing UserDataContext")
      clearUserData()
      console.log("💫 trigger revalidate")
      revalidator.revalidate()
    }
    // localStorage can be kept.
    // It's unusual that another user signs in, and if so, they may be presented with the ErrorBoundary and Refresh would clear the localStorage.
    // In the future, it may make sense to namespace user settings with the userId.
    console.log("redirect")
    navigate("/")
  }
}
